var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tables-wrapper"},[_c('div',{staticClass:"tables"},[_vm._t("default"),_c('footer-logo')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }